



























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { DropdownInput, TextInput, HiddenInput } from '@/components/FormInputs/FormInputs';
import TooltipDisplay from '@/components/FormInputs/TooltipDisplay.vue';
import IOption from '@/store/models/IOption';

@Component({
	name: 'AddressForm',
	components: {
		DropdownInput,
		TextInput,
		HiddenInput,
		TooltipDisplay,
	}
})
export default class AddressForm extends Vue {
	private forceRerenderKey: number = 0;

	@Prop() public id!: string;
	@Prop() public copyFromAddressId!: string;
	@Prop() public name!: string;
	@Prop() public label!: string;
	@Prop() public validateAddress!: boolean;
	@Prop() public errorMessage!: string;
	@Prop() public showTip: boolean;
	@Prop()	public toolTip: string;
	@Prop() public isRequiredAddress!: boolean;
	@Prop() public isStateDisabled!: boolean;
	@Prop() public isCountryDisabled!: boolean;

	public zipLength: number = 5;
	public isFocused: boolean = false;
	public focusedChildId: string='';

	public get formData(): any { return this.$store.getters['InterviewModule/formData'] }

	public created(): void {
		this.$root.$on('nestedDdChanged', (event: any) => {
			this.$nextTick(async () => {
				if (event.target.id.includes('Country')) { // Update Zip Length
					this.zipLength = event.target.value === 'US' ? 5 : 20;
				}

				if (event.target.id.includes('Country')) { // On change of country, update state list and set state/county to null
					await this.$store.dispatch('InterviewModule/getStatesForCountry', event.target.value);
					this.$store.commit('InterviewModule/updateFormDataKey', { key: `${this.id}.StateCode`, value: '' });
					this.$store.commit('InterviewModule/updateFormDataKey', { key: `${this.id}.CountyCode`, value: '' });
				}
				if (event.target.id.includes('State')) { // On change of state, update county list and set county to null
					await this.$store.dispatch('InterviewModule/getCountiesForState', {stateCode: event.target.value, countryCode: this.getFormDataKey(`${this.id}.CountryCode`) });
					this.$store.commit('InterviewModule/updateFormDataKey', { key: `${this.id}.CountyCode`, value: '' });
				}
			});
		});
		this.$root.$on('fieldChanged', (event: any) => {
			if (event.target.id !== 'DeleteInstance' && event.target.id.includes('Address')) {
				const keyParts = event.target.id.split('.');
				this.$store.commit('InterviewModule/updateFormDataKey', { key: keyParts[0] + ".IsValidated", value: false});
			}
		});
		this.$root.$on('formDataChanged', () => {
			this.rerender();
		});
	}

	private rerender(): void {
		this.forceRerenderKey++;
	}

	public onValidateAddressClick() {
		this.$store.commit('AddressModule/updateAddressToValidateId', this.id);
		this.$bvModal.show('AddressValidationModal');
	}

	public childFocused(id: string) {
		this.isFocused = true;
		this.focusedChildId = id;
	}

	public get getToolTip(): string {
		if (!!this.focusedChildId){
			let obj = JSON.parse(this.toolTip);
			return obj[this.focusedChildId];
		}

		return '';
	}

	public beforeDestroy() {
		this.$root.$off('nestedDdChanged');
	}
}
